import React from 'react';

// Shared Barrier Effectiveness display thresholds + the F.Exp pill style. Used by
// the main BE tab and its extracted sub-panels so the same numbers drive the
// silent-killer rule, the F.Exp tinting, the stable-trend cutoff, and the
// low-confidence dimming everywhere.

/** Silent-killer threshold: barriers above this Failure Exposure enter the Top N
 *  pool even when their Effectiveness Rate puts them in Healthy status. Mirrors
 *  the worker's constant — keep both in sync (barrier-analysis.worker.ts).
 *  Doubles as the "warning" tint threshold on the F.Exp column so the same
 *  number drives both the silent-killer rule and the visual scale. */
export const SILENT_KILLER_FEXP_THRESHOLD = 0.05;

/** F.Exp critical tint threshold (10 %). Above this, the column reads red so
 *  the eye finds the worst-exposed barriers ahead of the status chip. */
export const FEXP_CRITICAL_THRESHOLD = 0.10;

/** Soft low-confidence threshold for window-mode signals. When a barrier has
 *  fewer than this many challenges in the recent window, F.Exp / E.Trd / D.Trd
 *  are dimmed with a tooltip flagging the thin sample. Tuned above
 *  WINDOW_MIN_SLOPE_POINTS (3) so the dim band overlaps the smallest slopes
 *  that can render an arrow at all. */
export const LOW_CONFIDENCE_CHALLENGES = 5;

/** Slope threshold: absolute slope below this is considered stable (→). */
export const TREND_STABLE_THRESHOLD = 0.02;

/** Pill style for an F.Exp percentage value (0-100). Returns null below the
 *  warning threshold so small exposures stay visually quiet. */
export const fexpPillStyle = (pct: number): React.CSSProperties | null => {
    if (pct >= FEXP_CRITICAL_THRESHOLD * 100) {
        return {
            display: 'inline-block',
            padding: '1px 6px',
            borderRadius: 4,
            backgroundColor: 'rgba(211, 47, 47, 0.12)',
            color: '#d32f2f',
            fontWeight: 600,
        };
    }
    if (pct >= SILENT_KILLER_FEXP_THRESHOLD * 100) {
        return {
            display: 'inline-block',
            padding: '1px 6px',
            borderRadius: 4,
            backgroundColor: 'rgba(255, 152, 0, 0.12)',
            color: '#f57c00',
            fontWeight: 600,
        };
    }
    return null;
};
